import React, { useState } from 'react';
import { Modal, Select } from 'antd';
import Btn from '../Btn/Btn';
import { download } from '../../utils';

const MultipleReports = ({ reports, fetchReport }) => {
  const [visible, setVisible] = useState(false);
  const [selectedReportIds, setSelectedReportIds] = useState(new Set());
  const [loading, setLoading] = useState(false);

  const cancel = () => {
    setVisible(false);
    setSelectedReportIds(new Set());
  };

  const handleOk = async () => {
    setLoading(true);
    const reportsData = await Promise.allSettled(
      reports
        .filter((report) => selectedReportIds.has(report.id))
        .map((report) => fetchReport(report).then((data) => ({ data, report })))
    );
    setLoading(false);

    if (reportsData.length) {
      reportsData.forEach((reportData) => {
        const { value } = reportData;

        if (value.data) {
          download(value);
        }
      });
    }

    cancel();
  };

  return (
    <>
      <Btn
        tooltipProps={{ title: 'Отчеты' }}
        onClick={() => setVisible(true)}
      />
      <Modal
        visible={visible}
        okText="Загрузить отчеты"
        okButtonProps={{ disabled: !selectedReportIds.size }}
        title="Отчеты"
        onCancel={cancel}
        onOk={handleOk}
        maskClosable={false}
        confirmLoading={loading}
      >
        <Select
          style={{ width: '100%' }}
          mode="multiple"
          placeholder="Выберите отчеты"
          optionFilterProp="searchtext"
          value={Array.from(selectedReportIds)}
          onChange={(value) => setSelectedReportIds(new Set(value))}
          showSearch
          showArrow
        >
          {reports.map((report) => (
            <Select.Option
              key={report.id}
              value={report.id}
              searchtext={report.name}
            >
              {report.name}
            </Select.Option>
          ))}
        </Select>
      </Modal>
    </>
  );
};

export default MultipleReports;
